/* eslint-disable no-restricted-syntax */
import { featureFlagsSetLoadingAction, featureFlagsSetDataAction } from '@dtna/dvs-support-dcp-shared-state/lib/slices/featureFlags.slice';
import ERROR_DOMAIN from 'constants/errors';
import { PROXY_API } from 'constants/proxyApi';
import { store } from '../store';
import proxyApi from './proxyApi';

export const getFeatureFlags = async ({ tan = '', userEmail = '' }: { tan: string, userEmail: string}) => {
  try {
    featureFlagsSetLoadingAction(true)(store.dispatch);
    const { data: featureFlags } = await proxyApi.protectedRequest<string[]>({
      url: PROXY_API.GET.FEATURE_FLAGS.FLAGS,
      method: 'GET',
      params: { tan, userEmail },
    });
    featureFlagsSetDataAction(featureFlags)(store.dispatch);
    featureFlagsSetLoadingAction(false)(store.dispatch);
  } catch {
    featureFlagsSetDataAction([])(store.dispatch);
    featureFlagsSetLoadingAction(false)(store.dispatch);
    throw new Error(ERROR_DOMAIN.GENERIC_ERROR);
  }
};

export default getFeatureFlags;
